var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.homeData),function(group,idx){return _c('HomeSection',{key:idx,staticClass:"home-element",attrs:{"homeitem":group}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }